import ProtectedRoute from 'components/ProtectedRoute'
import React from 'react'
import { Switch } from 'react-router'
import Landing from './Landing'

const Cms: React.FC = () => {
  return (
    <div className="full-height grey-05-bkg">
      <Switch>
        <ProtectedRoute
          redirect="/"
          resource="Integrations"
          adminOnly
          exact
          path="/integrations"
          component={Landing}
        />
      </Switch>
    </div>
  )
}

export default Cms
